// src/components/contentHub/AiContentHub.js
import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import ProjectSelector from './ProjectSelector';
import ContentWorkflow from './ContentWorkflow';

/**
 * Acts as a dispatcher for the AI Content Hub.
 * - If a projectId is in the URL, it renders the full content generation workflow.
 * - If no projectId is in the URL, it renders a project selection screen.
 * - Passes ?draft= query param to ContentWorkflow for resume support.
 */
function AiContentHub() {
    const { projectId } = useParams();
    const [searchParams] = useSearchParams();
    const resumeDraftId = searchParams.get('draft') || null;

    return (
        projectId
            ? <ContentWorkflow projectId={projectId} resumeDraftId={resumeDraftId} />
            : <ProjectSelector />
    );
}

export default AiContentHub;
